import { Injectable, signal, computed } from '@angular/core';
import type { Brand } from '../models/brand.enum';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  readonly #brandSignal = signal<Brand | null>(null);

  readonly brand = computed(() => this.#brandSignal());

  setBrand(brand: Brand | null): void {
    this.#brandSignal.set(brand);
  }

  /**
   * Updates the favicon in the document head to match the current brand theme.
   * @param faviconPath Path to the favicon file
   */
  updateFavicon(faviconPath: string): void {
    // Remove existing favicon links
    const existingLinks = document.querySelectorAll('link[rel*="icon"]');
    existingLinks.forEach((link) => link.remove());

    // Create new favicon link
    const link = document.createElement('link');
    link.rel = 'icon';
    link.type = 'image/x-icon';
    link.href = faviconPath;
    document.head.appendChild(link);
  }
}
